<template>
   <div>
       <a-form-model :model="searchData" layout="inline"  ref="searchForm">
		<div style="display:flex;flex-wrap: wrap">
          <slot name="formItem"></slot> 
           <a-form-model-item>
              <a-button type="primary" icon="search"  @click="getSearchData(0)">查询</a-button> 
           </a-form-model-item>
           <a-form-model-item v-if="mulselect">
              <a-button type="primary" icon="delete"  @click="muldelete">批量删除</a-button> 
           </a-form-model-item>
           <slot name="addAction" v-bind="{showModal}"></slot>
           <slot name="otherBarOperation" v-bind="{reloadtabledata,getSearchData}" ></slot>
		</div>
       </a-form-model>

       <a-modal v-model="modalinfo.visible" :width="modalinfo.width" :title="modalinfo.title" cancelText="取消" okText="确定" @ok="onOk">
           <a-form-model :model="formData" :label-col="{ span: 7 }" :wrapper-col="{ span: 13 }">
			<template v-if="saveinputs">
				<a-form-model-item v-for="item in saveinputs" :key="item.name" :label="item.title">
					<slot v-if="item.slotname" :name="item.slotname">
					</slot>
					<a-input v-else :placeholder="'请输入'+item.title" v-model="formData[item.name]"></a-input>
				</a-form-model-item>
			</template>
            <slot name="itemFormData"></slot>
           </a-form-model>
       </a-modal>
       <slot name="totalinfo" v-bind="{tabledata}"></slot>
       <a-table
        v-bind="{...$props,columns,loading,rowKey}"
        :data-source="dataSource"
        :pagination="false"
		:scroll="{x:true}"
        :row-selection="mulselect?{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}:undefined"
       >
       <template v-slot:action="record">
           <slot name="tableAction" v-bind="{record,showModal,showDelConfirm,getSearchData}"></slot>
        </template>
        <template v-slot:tindex="_,__,index">
            {{index+1}}
        </template>
        <template v-slot:enum="text">
            <slot name="meiju" v-bind="{text}"></slot>
        </template>
        <template v-for="item in trRender"  v-slot:[item]="text,record">
            <slot :name="item" v-bind="{text,record}"></slot>
        </template> 
       </a-table>

       <a-pagination :current="current" :pageSize="pageSize" :total="total"
        showSizeChanger
        size="small"
		:pageSizeOptions="['10','20','30','50','100','1000']"
        :show-total="t => `共 ${t} 条数据`"
        @change="pageChange"
		@showSizeChange="pageSizeChange"
        >
           <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
           </template>
       </a-pagination>
   </div> 
</template>

<script>
import Mycurd from './data.js'
export default Mycurd
</script>

<style lang="less" scoped >
@import "index.less";
</style>


